import { ActionType } from '../action-types/index'
import { UpdateSideMenuStateAction } from '../actions/index'
import { SideMenuState } from "../../models"

const initialAppState: SideMenuState = SideMenuState.Closed

const sideMenuStateReducer = (state: number = initialAppState, action: UpdateSideMenuStateAction) => {
    switch (action.type) {
        case ActionType.UpdateSideMenu:
            return state = action.payload
        default:
            return state
    }
}

export default sideMenuStateReducer